import { Footer, RoutesInside } from "@general-backoffice/core";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Container } from "reactstrap";

import AuthHeader from "../../components/auth/AuthHeader";
import LanguageSelectorModal from "../../components/shared/LanguageSelectorModal";
import useFooterContent from "../../hooks/useFooterContent";
import logoLight from "../../media/branding/logo-light.png";

interface AuthProps {
  children?: React.ReactNode;
}

const Auth: React.FC<AuthProps> = ({ children }) => {
  const { t } = useTranslation();
  const [isOpenLanguage, setOpenLanguage] = useState(false);
  const footerContent = useFooterContent();

  return (
    <>
      <LanguageSelectorModal isOpen={isOpenLanguage} setOpen={setOpenLanguage} />

      <Container fluid className="bg-default p-0 m-0 min-vh-100">
        <AuthHeader
          logoSrc={logoLight}
          logoStyle={{ height: 55 }}
          onClickLogo={() => {
            window.location.href = "https://investhinks.com/";
          }}
          onClickLanguage={() => setOpenLanguage(true)}
          languageTitle={t("dropdown.language")}
        />
        {children || <RoutesInside />}
        <Footer.Auth brand="INVESTHINKS" content={footerContent} />
      </Container>
    </>
  );
};

export default Auth;
